import m from "../../geodata/es2015/switzerlandLow";
window.am4geodata_switzerlandLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/switzerlandLow.js
// module id = null
// module chunks = 